import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Home from '../components/home'
// import Mytest from "@/views/Mytest";

Vue.use(VueRouter)
/**
 * hidden: true:此时当前组件不在页面导航栏显示
 * hidden: false:此时当前组件在页面导航栏显示
 * hidden未设置时默认为false，此时组件会在导航栏上面显示
 */
const routes = [{ // 主界面
  path: '/',
  name: 'Home',
  hidden: true,
  component: Home
},
// { // 主界面
//   path: '/mytest',
//   name: 'Mytest',
//   hidden: true,
//   component: Mytest: () => import( /* webpackChunkName: "helpDocument" */
// '../components/system/helpDocument')
// },
{ // 主界面
  path: '/help',
  name: 'Help',
  hidden: true,
  meta: {
    title: '帮助',
    i18n: 'router.help'
  },
  component: () => import( /* webpackChunkName: "helpDocument" */
    '../components/system/helpDocument')
},
{ // 登录页面
  path: '/login',
  name: 'Login',
  hidden: true,
  meta: {
    title: 'LOGIN',
    navIsShow: true
  },
  component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
},
{ // 媒体库
  path: '/explorer',
  name: 'Explorer',
  hidden: false,
  meta: {
    title: '素材管理',
    isKeep: true,
    i18n: 'router.material'
  },
  component: () => import( /* webpackChunkName: "Explorer" */ '../views/Explorer.vue'),
  children: [{
    path: 'mediaList',
    name: 'MediaList',
    hidden: true,
    meta: {
      title: '媒体列表',
      i18n: 'ri3'
    },
    component: () => import( /* webpackChunkName: "MediaList" */ '../components/explorer/MediaList')
  },
  {
    path: 'newMediaList',
    name: 'NewMediaList',
    hidden: false,
    meta: {
      title: '新媒体列表',
      isKeep: true,
      i18n: 'ri4'
    },
    component: () => import( /* webpackChunkName: "MediaList" */ '../components/explorer/NewMediaList')
  },
  {
    path: 'mediaUp',
    name: 'MediaUp',
    hidden: true,
    meta: {
      title: '媒体上传',
      i18n: 'ri5'
    },
    component: () => import( /* webpackChunkName: "one" */ '../components/explorer/MediaUp')
  }
  ]
},
{ // 播放日程
  path: '/schedule',
  name: 'Schedule',
  hidden: false,
  meta: {
    title: '节目编辑',
    i18n: 'router.editProgramme'
  },
  component: () => import( /* webpackChunkName: "schedule" */ '../views/Schedule.vue'),
  children: [{
    path: 'programManage',
    name: 'ProgramManage',
    meta: {
      title: '节目编辑',
      i18n: 'router.editProgramme'
    },
    component: () => import( /* webpackChunkName: "ProgramManage" */
      '../components/schedule/ProgramManage')
  },
  {
    path: 'interCutManage',
    name: 'InterCutManage',
    hidden: true,
    meta: {
      title: '插播管理',
      i18n: 'ri9'
    },
    component: () => import( /* webpackChunkName: "InterCutManage" */
      '../components/schedule/InterCutManage')
  },
  {
    path: 'addSchedule',
    name: 'AddSchedule',
    hidden: true,
    meta: {
      title: '权限配置',
      i18n: 'ri10'
    },
    component: () => import( /* webpackChunkName: "AddSchedule" */
      '../components/schedule/children/AddSchedule')
  },
  {
    path: 'newInterCut',
    name: 'NewInterCut',
    hidden: true,
    meta: {
      title: '新建插播',
      i18n: 'ri11'
    },
    component: () => import( /* webpackChunkName: "AcquisitionDevice" */
      '../components/schedule/children/NewInterCut')
  },
  {
    path: 'windowsIndex',
    name: 'WindowsIndex',
    hidden: true,
    meta: {
      title: '节目编辑窗口',
      i18n: 'ri12'
    },
    component: () => import( /* webpackChunkName: "AcquisitionDevice" */
      '../components/schedule/windows/index')
  },
  {
    path: 'playList',
    // path: 'playList/:plan_type',
    name: 'PlayList',
    hidden: true,
    meta: {
      title: '节目发布窗口',
      i18n: 'ri13'
    },
    component: () => import( /* webpackChunkName: "AcquisitionDevice" */
      '../components/schedule/PlayList')
  }
  ]
},
// { // 高级发布
//   path: '/advancedRelease',
//   name: 'AdvancedRelease',
//   hidden: false,
//   meta: {
//     title: '高级发布',
//     i18n: 'router.publishProgramme'
//   },
//   component: () => import( /* webpackChunkName: "schedule" */ '../views/AdvancedRelease.vue'),
//   children: [
//     {
//       path: 'issueManage',
//       name: 'IssueManage',
//       meta: {
//         title: '高级发布',
//         i18n: 'router.publishProgramme'
//       },
//       component: () => import( /* webpackChunkName: "IssueManage" */
//         '../components/schedule/IssueManage'),
//     },
//   ]
// },
{ // 高级发布
  path: '/advancedRelease',
  name: 'AdvancedRelease',
  hidden: false,
  meta: {
    title: '高级发布',
    i18n: 'router.publishProgramme'
  },
  component: () => import( /* webpackChunkName: "schedule" */ '../components/advancedRelease/index'),
},
{
  path: '/terminal',
  name: 'Terminal',
  hidden: false,
  isChild: false,
  meta: {
    title: '终端管理',
    i18n: 'router.terminal'
  },
  component: () => import( /* webpackChunkName: "System" */ '../views/Terminal.vue'),
  children: [
    {
      path: 'Control',
      name: 'Control',
      meta: {
        title: '终端管理',
        i18n: 'ri24'
      },
      component: () => import( /* webpackChunkName: "Control" */
        '../components/terminal/Control')
    }
  ]
},
{ // 审核
  path: '/review',
  name: 'Review',
  hidden: false,
  meta: {
    title: '审核管理',
    i18n: 'router.check'
  },
  component: () => import( /* webpackChunkName: "Review" */ '../views/Review.vue'),
  children: [{
    path: 'materialCheck',
    name: 'MaterialCheck',
    hidden: false,
    meta: {
      title: '素材审核',
      i18n: 'router.checkMaterial'
    },
    component: () => import( /* webpackChunkName: "MaterialCheck" */
      '../components/review/MaterialCheck')
  },
  {
    path: 'programCheck',
    name: 'ProgramCheck',
    hidden: false,
    meta: {
      title: '节目审核',
      i18n: 'router.checkProgramme'
    },
    component: () => import( /* webpackChunkName: "ProgramCheck" */
      '../components/review/ProgramCheck')
  },
  {
    path: 'issueCheck',
    name: 'IssueCheck',
    meta: {
      title: '发布审核',
      i18n: 'router.checkPublish'
    },
    component: () => import( /* webpackChunkName: "IssueCheck" */ '../components/review/IssueCheck')
  },
  {
    path: 'countersCheck',
    name: 'countersCheck',
    meta: {
      title: '定时指令',
      i18n: 'aci4'
    },
    component: () => import( /* webpackChunkName: "IssueCheck" */ '../components/review/CountersCheck')
  },
  {
    path: 'checkManage',
    name: 'CheckManage',
    hidden: true,
    meta: {
      title: '审核管理',
      i18n: 'ri19'
    },
    component: () => import( /* webpackChunkName: "CheckManage" */
      '../components/review/CheckManage')
  }
  ]
},
{
  path: '/log',
  name: 'Log',
  hidden: false,
  meta: {
    title: '日志管理',
    i18n: 'router.log'
  },
  component: () => import( /* webpackChunkName: "System" */ '../views/Log.vue'),
  children: [{
    path: 'loginlLog',
    name: 'LoginlLog',
    meta: {
      title: '登录日志',
      i18n: 'router.logLogin'
    },
    component: () => import( /* webpackChunkName: "LoginlLog" */
      '../components/log/LoginLog')
  },
  {
    path: 'operationLogs',
    name: 'OperationLogs',
    meta: {
      title: '操作日志',
      i18n: 'router.logOperation'
    },
    component: () => import( /* webpackChunkName: "OperationLogs" */
      '../components/log/OperationLog')
  },
  {
    path: 'terminalLogs',
    name: 'TerminalLogs',
    hidden: process.env.VUE_APP_INDIA === 'true',
    meta: {
      title: '终端日志',
      i18n: 'router.logTerminal'
    },
    component: () => import( /* webpackChunkName: "TerminalLog" */
      '../components/log/TerminalLog')
  }
  ]
},
{ // 终端管理
  path: '/device',
  name: 'Device',
  hidden: true,
  meta: {
    title: '终端管理',
    i18n: 'ri24'
  },
  component: () => import( /* webpackChunkName: "Device" */ '../views/Device.vue'),
  children: [{
    path: 'terminalControl',
    name: 'TerminalControl',
    component: () => import( /* webpackChunkName: "System" */ '../views/Log.vue'),
    // children: [{
    //   path: 'loginlLog',
    //   name: 'LoginlLog',
    //   meta: {
    //     title: '登录日志'
    //   },
    //   component: () => import( /* webpackChunkName: "LoginlLog" */
    //     '../components/Log/LoginLog')
    // },
    //   {
    //     path: 'operationLogs',
    //     name: 'OperationLogs',
    //     meta: {
    //       title: '操作日志'
    //     },
    //     component: () => import( /* webpackChunkName: "OperationLogs" */
    //       '../components/Log/OperationLog')
    //   },
    //   {
    //     path: 'terminalLogs',
    //     name: 'TerminalLogs',
    //     meta: {
    //       title: '终端日志'
    //     },
    //     component: () => import( /* webpackChunkName: "TerminalLog" */
    //       '../components/Log/TerminalLog')
    //   }
    // ]
  },
  // { // 终端管理
  //   path: '/device',
  //   name: 'Device',
  //   hidden: true,
  //   meta: {
  //     title: '终端控制'
  //   },
  //   component: () => import( /* webpackChunkName: "TerminalControl" */
  //     '../components/device/TerminalControl')
  // },
  {
    path: 'terminalManage',
    name: 'TerminalManage',
    meta: {
      title: '终端管理',
      i18n: 'ri24'
    },
    component: () => import( /* webpackChunkName: "TerminalManage" */
      '../components/device/TerminalManage')
  },
  {
    path: 'terminalLog',
    name: 'TerminalLog',
    meta: {
      title: '终端日志',
      i18n: 'ri23'
    },
    component: () => import( /* webpackChunkName: "TerminalLog" */
      '../components/device/TerminalLog')
  },
  {
    path: 'kommanderDetails',
    name: 'KommanderDetails',
    hidden: true,
    meta: {
      title: '终端详情', // Kommander
      i18n: 'ri25' // Kommander

    },
    component: () => import( /* webpackChunkName: "KommanderDetails" */
      '../components/device/children/KommanderDetails')
  },
  {
    path: 'pandoraDetails',
    name: 'PandoraDetails',
    hidden: true,
    meta: {
      title: '终端详情', // Pandora
      i18n: 'ri25'
    },
    component: () => import( /* webpackChunkName: "PandoraDetails" */
      '../components/device/children/PandoraDetails')
  },
  {
    path: 'acquisitionDevice',
    name: 'AcquisitionDevice',
    hidden: true,
    meta: {
      title: '获取设备',
      i18n: 'ri26'
    },
    component: () => import( /* webpackChunkName: "AcquisitionDevice" */
      '../components/device/children/AcquisitionDevice')
  }
  ]
},
{ // 系统配置
  path: '/system',
  name: 'System',
  hidden: false,
  meta: {
    title: '高级管理',
    i18n: 'router.seniorManagement'
  },
  component: () => import( /* webpackChunkName: "System" */ '../views/System.vue'),
  children: [{
    path: 'organizationManage',
    name: 'OrganizationManage',
    meta: {
      title: '组织结构',
      i18n: 'router.organization'
    },
    component: () => import( /* webpackChunkName: "OrganizationManage" */
      '../components/system/OrganizationManage')
  },
  {
    path: 'mediaManage',
    name: 'MediaManage',
    hidden: true,
    meta: {
      title: '媒体目录管理',
      i18n: 'ri29'
    },
    component: () => import( /* webpackChunkName: "MediaManage" */
      '../components/system/MediaManage')
  },
  {
    path: 'operationLog',
    name: 'OperationLog',
    hidden: true,
    meta: {
      title: '操作日志',
      i18n: 'ri22'
    },
    component: () => import( /* webpackChunkName: "OperationLog" */
      '../components/system/OperationLog')
  },
  {
    path: 'userManage',
    name: 'UserManage',
    meta: {
      title: '用户管理',
      i18n: 'router.userManage'
    },
    component: () => import( /* webpackChunkName: "UserManage" */ '../components/system/UserManage')
  },
  {
    path: 'roleManage',
    name: 'RoleManage',
    meta: {
      title: '角色管理',
      i18n: 'router.RoleManage'
    },
    component: () => import( /* webpackChunkName: "RoleManage" */ '../components/system/RoleManage')
  },
  {
    path: 'systemLayout',
    name: 'SystemLayout',
    meta: {
      title: '系统设置',
      i18n: 'router.systemLayout'
    },
    component: () => import( /* webpackChunkName: "SystemLayout" */
      '../components/system/SystemLayout')
  },
  {
    path: 'nodeManage',
    name: 'NodeManage',
    hidden: process.env.NODE_ENV === 'production',
    meta: {
      title: '节点管理',
      i18n: 'router.nodeManage'
    },
    component: () => import( /* webpackChunkName: "NodeManage" */ '../components/system/NodeManage')
  },
  {
    path: 'personalCenter',
    name: 'PersonalCenter',
    hidden: true,
    meta: {
      title: '个人中心',
      i18n: 'ri34'
    },
    component: () => import( /* webpackChunkName: "PersonalCenter" */
      '../components/system/PersonalCenter')
  },
  {
    path: 'accessLayout',
    name: 'AccessLayout',
    hidden: true,
    meta: {
      title: '权限配置',
      i18n: 'ri35'
    },
    component: () => import( /* webpackChunkName: "AccessLayout" */
      '../components/system/children/AccessLayout')
  },
  {
    path: 'reviewSetting',
    name: 'ReviewSetting',
    hidden: false,
    meta: {
      title: '审核设置',
      i18n: 'router.reviewSet'
    },
    component: () => import( /* webpackChunkName: "ReviewSetting" */
      '../components/system/ReviewSetting')
  },
  // {
  //   path: 'softwareLicence',
  //   name: 'SoftwareLicence',
  //   hidden: false,
  //   meta: {
  //     title: '软件授权',
  //     i18n:'router.softwareLicence'
  //   },
  //   component: () => import( /* webpackChunkName: "SoftwareLicence" */
  //     '../components/system//SoftwareLicence')
  // },
  {
    path: 'referralCode',
    name: 'ReferralCode',
    hidden: true,
    meta: {
      title: '推荐码',
      i18n: 'ri37'
    },
    component: () => import( /* webpackChunkName: "ReviewSetting" */
      '../components/system/ReferralCode')
  },
  {
    path: 'UrgentContent',
    name: 'UrgentContent',
    hidden: true,
    meta: {
      title: '紧急内容配置',
      i18n: 'ri38'
    },
    component: () => import( /* webpackChunkName: "ReviewSetting" */
      '../components/system/UrgentContent')
  },
  {
    path: 'pointDelivery',
    name: 'PointDelivery',
    hidden: process.env.VUE_APP_CPT === 'false',
    meta: {
      title: '定点投放',
      i18n: 'rifp'
    },
    component: () => import( /* webpackChunkName: "ReviewSetting" */
      '../components/system/PointDelivery'),
  },
  {
    path: 'addPoint',
    name: 'AddPoint',
    hidden: true,
    meta: { title: '添加播放点' },
    component: () => import('../components/system/children/AddPoint'),
  },
  {
    path: 'addGooglePoint',
    name: 'AddGooglePoint',
    hidden: true,
    meta: { title: '添加谷歌地图播放点' },
    component: () => import('../components/system/children/AddGooglePoint'),
  },
  {
    path: 'templateManagement',
    name: 'TemplateManagement',
    hidden: true,
    meta: {
      title: '模板管理',
      i18n: 'ritm'
    },
    component: () => import( /* webpackChunkName: "SoftwareLicence" */
      '../components/system/TemplateManagement'),
    children: [{
      path: 'ProgramTemplate',
      name: 'ProgramTemplate',
      hidden: true,
      meta: {
        title: '节目模板管理'
      },
      component: () => import('../components/system/temchildren/ProgramTemplate'),
    },
    {
      path: 'Material',
      name: 'Material',
      hidden: true,
      meta: {
        title: '素材管理'
      },
      component: () => import('../components/system/temchildren/Material'),
    },
    {
      path: 'Font',
      name: 'Font',
      hidden: true,
      meta: {
        title: '字体库管理'
      },
      component: () => import('../components/system/temchildren/Font'),
    },
    {
      path: 'WebTools',
      name: 'WebTools',
      hidden: true,
      meta: {
        title: '网页工具'
      },
      component: () => import('../components/system/temchildren/WebTools'),
    }
    ]
  },
  {
    path: 'spaceManage',
    name: 'SpaceManage',
    meta: {
      title: '存储管理',
      i18n: 'spaceManage'
    },
    component: () => import( /* webpackChunkName: "SpaceManage" */
      '../components/system/SpaceManage')
  },
  {
    path: 'testTecords',
    name: 'TestTecords',
    hidden: process.env.VUE_APP_VERSION !== '81',
    meta: {
      title: '测试管理',
      i18n: 'Test'
    },
    component: () => import( /* webpackChunkName: "SpaceManage" */
      '../components/system/testTecords/TestTecords'),
    children: [{
      path: 'versionList',
      name: 'VersionList',
      hidden: true,
      meta: {
        title: '测试版本配置'
      },
      component: () => import( /* webpackChunkName: "VersionList" */
        '../components/system/testTecords/VersionList')
    }]
  }
  ]
},
{ // 终端管理
  path: '/uploadResume',
  name: 'UploadResume',
  hidden: true,
  meta: {
    title: '断点续传测试',
    i18n: 'ri39'
  },
  component: () => import( /* webpackChunkName: "UploadResume" */ '../test/uploadResume.vue'),
  children: []
}]

const router = new VueRouter({
  mode: 'history', //上线打包安卓的时候需要注释history模式，修改为hash模式
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 重复跳转同一路由报错抛出错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 跳过路由守卫
let filterPath = ['ReferralCode', 'Help'];

router.beforeEach((to, from, next) => {
  if (filterPath.indexOf(to.name) > -1) {
    next();
    return;
  }
  if (to.name !== 'Login' && Vue.$cookies.get("isLogin") !== '1') {
    next({ path: "/login" });
  } else {
    next();
  }
})

export default router
